export default __webpack_public_path__ + "static/media/star.49b9550c.svg";